import { createFeatureSelector, createSelector } from '@ngrx/store';
import { configurationFeatureKey } from '../reducers/configuration.reducer';
import { ConfigurationState } from '../state';

export const selectConfigurationState =
  createFeatureSelector<ConfigurationState>(configurationFeatureKey);

export const selectAgentsConfiguration = createSelector(
  selectConfigurationState,
  (state) => state.agents,
);
export const selectEWalletConfiguration = createSelector(
  selectConfigurationState,
  (state) => state.ewallet,
);
export const selectNotificationsConfiguration = createSelector(
  selectConfigurationState,
  (state) => state.notifications,
);
export const selectPaymentCenterConfiguration = createSelector(
  selectConfigurationState,
  (state) => state.paymentCenter,
);
export const selectFtConnectConfiguration = createSelector(
  selectConfigurationState,
  (state) => state.ftconnect,
);
export const selectIsConfigurationLoading = createSelector(
  selectConfigurationState,
  (state) => state.loading,
);

export const paymentCenterSelectors = {
  selectPaymentRequestConfiguration: createSelector(
    selectPaymentCenterConfiguration,
    (config) => config?.paymentRequests,
  ),
};
